//wordpress dependencies
const { __ } = wp.i18n;
const { InspectorControls, PanelColorSettings, MediaUpload } = wp.blockEditor;
import {
	ColorPalette, TextControl, BaseControl, Button, ButtonGroup, Dropdown, PanelBody, RangeControl, SelectControl, TabPanel, ToggleControl, __experimentalUnitControl as UnitControlEMG
} from "@wordpress/components";
import axios from "axios";
import Qs from 'qs';
import Select from 'react-select';
import ColorControl from "../../util/color-control";
import DimensionsControl from "../../util/dimensions-control";
import UnitControl from "../../util/unit-control";
import { COL_OPTIONS, FONT_WEIGHTS, ICON_OPTIONS, NORMAL_HOVER, ORDER_OPTIONS, SORT_OPTIONS, STYLE_OPTIONS, TEXT_TRANSFORM, ALIGNMENT, COLORS, BORDER_STYLES, AUTOPLAY_DELAY, DOT_STYLE_OPTIONS, ARROW_POSITION } from "./constants";
const { useEffect, useState } = wp.element;

function Inspector(props) {
	const { attributes, setAttributes, catSideQueryChange } = props;
	const {
		cats,
		orderby,
		sortby,
		hide_empty,
		count_child,
		icon_type,
		image_size,
		custom_image_width,
		custom_image_height,
		content_limit,
		category_limit,
		sub_category_limit,
		sub_cat_padding,
		col_xl,
		col_lg,
		col_md,
		col_sm,
		col_mobile,
		content_visibility,
		col_padding,
		col_style,
		container_padding,
		container_margin,
		containerBGColor,
		enable_parent,
		count_after_text,
		header_padding,
		content_margin,
		counter_margin,
		title_margin,
		colBGColorStyle,
		colBGColor,
		colBGHoverColor,
		colBorderColor,
		colBorderWith,
		colBorderRadius,
		colGutterSpace,
		colBoxShadow,
		colBoxShadowHover,
		colBoxShadowStyle,
		iconColorStyle,
		iconColor,
		iconHoverColor,
		iconBGColor,
		iconFontSize,
		iconArea,
		iconBorderColor,
		iconBorderWith,
		iconBorderStyle,
		iconBorderRadius,
		titleColorStyle,
		titleColor,
		titleHoverColor,
		titleTypo,
		counterColorStyle,
		counterColor,
		counterHoverColor,
		counterFontSize,
		contentTypo,
		contentColorStyle,
		contentColor,
		contentHoverColor,
		headerColorStyle,
		headerBGColor,
		headerHoverBGColor,
		headerBDColor,
		headerHoverBDColor,
		subCatColorStyle,
		subCatColor,
		subCatHoverColor,
		subCatIconColor,
		subCatIconHoverColor,
		subCatFontSize,
		slider_options,
		arrowBGColor,
		arrowBGHoverColor,
		arrowIconColor,
		arrowIconHoverColor,
		dotBGColor,
		dotActiveBGColor,
		dotSpacing,

	} = attributes;

	const TITLE_SIZE_MAX = titleTypo["size"]["unit"] === "em" ? 10 : 100;
	const TITLE_SIZE_STEP = titleTypo["size"]["unit"] === "em" ? 0.1 : 1;
	const CONTENT_SIZE_MAX = contentTypo["size"]["unit"] === "em" ? 10 : 100;
	const CONTENT_SIZE_STEP = contentTypo["size"]["unit"] === "em" ? 0.1 : 1;

	const [catList, setCatList] = useState([]);
	const [imageSize, setImageSize] = useState([]);

	useEffect(() => {
		let data = {
			action: 'rtcl_gb_get_all_image_size_ajax',
			rtcl_nonce: rtcl_block_script.rtcl_nonce,
		}

		axios.post(rtcl_block_script.ajaxurl, Qs.stringify(data))
			.then((response) => {
				if (response.data.data) {
					let imageSize = [];
					let ai = 0;
					for (const [value, label] of Object.entries(response.data.data)) {
						imageSize[ai] = { value, label };
						ai++;
					}
					setImageSize([...imageSize])
				} else {
					setImageSize([])
				}
			})
			.catch((error) => console.log(error));
	}, []);


	useEffect(() => {
		let data = {
			action: 'rtcl_gb_categories',
			rtcl_nonce: rtcl_block_script.rtcl_nonce,
			portion: 'catbox'
		}

		axios.post(rtcl_block_script.ajaxurl, Qs.stringify(data))
			.then((response) => {

				let catListings = [];
				let ai = 0;
				for (const [value, label] of Object.entries(response.data)) {
					catListings[ai] = { value, label };
					ai++;
				}
				setCatList([...catListings])
			})
			.catch((error) => console.log(error));
	}, []);

	return (
		<InspectorControls key="controls">
			<div className="rtcl-gb-panel-control">
				<TabPanel
					className="rtcl-gb-parent-tab-panel"
					activeClass="active-tab"
					// onSelect={onSelect}
					tabs={[
						{
							name: "general",
							title: "General",
							className: "rtcl-gb-tab general",
						},
						{
							name: "styles",
							title: "Styles",
							className: "rtcl-gb-tab styles",
						},
						{
							name: "advance",
							title: "Advance",
							className: "rtcl-gb-tab advance",
						},
					]}
				>
					{(tab) => (
						<div className={"rtcl-gb-tab-controls" + tab.name}>

							{tab.name === "general" && (
								<>
									<PanelBody title={__("Layout", "classified-listing")} initialOpen={true}>
										<SelectControl
											label={__('Style', 'classified-listing')}
											options={rtcl_block_localize_obj.category.style_options}
											value={col_style["style"]}
											onChange={(style) => {
												setAttributes({ col_style: { ...col_style, style } })
											}}
										/>
									</PanelBody>
									<PanelBody title={__("Filter", "classified-listing")} initialOpen={false}>

										<div className="components-base-control__field">
											<label className="components-base-control__label" htmlFor="react-select-2-input">{__('Categories', 'classified-listing')}</label>
											<Select
												options={catList}
												value={cats}
												onChange={(value) => {
													setAttributes({ cats: value }),
														catSideQueryChange()
												}}
												isMulti={true}
												closeMenuOnSelect={false}
											/>
										</div>
										<ToggleControl
											label={__("Only Parent Category", "classified-listing")}
											checked={enable_parent}
											onChange={(enable_parent) => {
												setAttributes({ enable_parent }),
													catSideQueryChange()
											}}
										/>
										<SelectControl
											label={__('Order By', 'classified-listing')}
											options={ORDER_OPTIONS}
											value={orderby}
											onChange={(value) => {
												setAttributes({ orderby: value }),
													catSideQueryChange()
											}}
										/>
										<SelectControl
											label={__('Short By', 'classified-listing')}
											options={SORT_OPTIONS}
											value={sortby}
											onChange={(value) => {
												setAttributes({ sortby: value }),
													catSideQueryChange()
											}}
										/>
										<RangeControl
											label={__('Category Limit', 'classified-listing')}
											allowReset={true}
											value={category_limit}
											onChange={(value) => {
												setAttributes({ category_limit: value }),
													catSideQueryChange()
											}}
											min={1}
											max={100}
										/>

										{col_style["style"] == '2' && <>
											<ToggleControl
												label={__("Show Child Category", "classified-listing")}
												checked={content_visibility["subCat"]}
												onChange={(subCat) => {
													setAttributes({ content_visibility: { ...content_visibility, subCat } })
												}}
											/>
											{content_visibility["subCat"] && <RangeControl
												label={__('Sub Category Limit', 'classified-listing')}
												allowReset={true}
												value={sub_category_limit}
												onChange={(sub_category_limit) => {
													setAttributes({ sub_category_limit }),
														catSideQueryChange()
												}}
												min={1}
												max={100}
											/>}
										</>}
										<ToggleControl
											label={__("Counts Include Children", "classified-listing")}
											checked={count_child}
											onChange={(count_child) => {
												setAttributes({ count_child }),
													catSideQueryChange()
											}}
										/>

										<ToggleControl
											label={__("Hide Empty", "classified-listing")}
											checked={hide_empty}
											onChange={(hide_empty) => {
												setAttributes({ hide_empty }),
													catSideQueryChange()
											}}
										/>
										<ToggleControl
											label={__("Show Icon", "classified-listing")}
											checked={content_visibility["icon"]}
											onChange={(icon) => {
												setAttributes({
													content_visibility: { ...content_visibility, icon }
												})
											}}
										/>

										{content_visibility["icon"] && <SelectControl
											label={__('Icon Type', 'classified-listing')}
											options={ICON_OPTIONS}
											value={icon_type}
											onChange={(value) => {
												setAttributes({ icon_type: value }),
													catSideQueryChange()
											}}
										/>}

										{icon_type === 'image' &&
											<SelectControl
												label={__('Image Size', 'classified-listing')}
												options={imageSize}
												value={image_size}
												onChange={(value) => {
													setAttributes({ image_size: value }),
														catSideQueryChange()
												}}
											/>
										}

										{image_size == 'custom' &&
											<>
												<RangeControl
													label={__('Width', 'classified-listing')}
													value={custom_image_width}
													onChange={(value) => {
														setAttributes({ custom_image_width: value }),
															catSideQueryChange()
													}}
													min={2}
													max={1000}
													step={2}
												/>
												<RangeControl
													label={__('Height', 'classified-listing')}
													value={custom_image_height}
													onChange={(value) => {
														setAttributes({ custom_image_height: value }),
															catSideQueryChange()
													}}
													min={2}
													max={1000}
													step={2}
												/>
											</>
										}
										<ToggleControl
											label={__("Show Count", "classified-listing")}
											checked={content_visibility["counter"]}
											onChange={(counter) => {
												setAttributes({ content_visibility: { ...content_visibility, counter } })
											}}
										/>

										{content_visibility["counter"] &&
											<TextControl
												label={__("Count Text")}
												value={count_after_text}
												onChange={(count_after_text) => setAttributes({ count_after_text })}
											/>
										}

										<ToggleControl
											label={__("Show Description", "classified-listing")}
											checked={content_visibility["catDesc"]}
											onChange={(catDesc) => {
												setAttributes({
													content_visibility: { ...content_visibility, catDesc }
												})
											}}
										/>

										{content_visibility["catDesc"] && <RangeControl
											label={__('Description Limit', 'classified-listing')}
											value={content_limit}
											onChange={(value) => setAttributes({ content_limit: value })}
											min={2}
											max={100}
										/>}

										<SelectControl
											label={__('Content Alignment', 'classified-listing')}
											options={ALIGNMENT}
											value={content_visibility["contentAlign"]}
											onChange={(contentAlign) => {
												setAttributes({ content_visibility: { ...content_visibility, contentAlign } })
											}}
										/>

									</PanelBody>

									<PanelBody title={__('Slider Options', 'classified-listing')} initialOpen={false}>

										<ToggleControl
											label={__("Auto Heighit", "classified-listing")}
											checked={slider_options["autoHeight"]}
											onChange={(autoHeight) => {
												setAttributes({ slider_options: { ...slider_options, autoHeight } })
											}}
										/>

										<ToggleControl
											label={__("Loop", "classified-listing")}
											checked={slider_options["loop"]}
											onChange={(loop) => {
												setAttributes({ slider_options: { ...slider_options, loop } })
											}}
										/>

										<div style={{ marginBottom: '10px' }}>
											<ToggleControl
												label={__("Autoplay", "classified-listing")}
												checked={slider_options["autoPlay"]}
												onChange={(autoPlay) => {
													setAttributes({ slider_options: { ...slider_options, autoPlay } })
												}}
											/>

										</div>

										{slider_options["autoPlay"] == true && <>
											<ToggleControl
												label={__("Stop On Hover", "classified-listing")}
												checked={slider_options["stopOnHover"]}
												onChange={(stopOnHover) => {
													setAttributes({ slider_options: { ...slider_options, stopOnHover } })
												}}
											/>
											<SelectControl
												label={__('Autoplay Delay', 'classified-listing')}
												options={AUTOPLAY_DELAY}
												value={slider_options["autoPlayDelay"]}
												onChange={(autoPlayDelay) => {
													setAttributes({ slider_options: { ...slider_options, autoPlayDelay } })
												}}
											/>
										</>}

										<RangeControl
											label={__('Slide Transition Speed', 'classified-listing')}
											value={slider_options["autoPlaySlideSpeed"]}
											onChange={(autoPlaySlideSpeed) => setAttributes({ slider_options: { ...slider_options, autoPlaySlideSpeed } })}
											min={1000}
											max={5000}
										/>

										<RangeControl
											label={__('Space Between', 'classified-listing')}
											value={slider_options["spaceBetween"]}
											onChange={(spaceBetween) => setAttributes({ slider_options: { ...slider_options, spaceBetween } })}
											min={0}
											max={100}
										/>

										<ToggleControl
											label={__("Arrow Navigation", "classified-listing")}
											checked={slider_options["arrowNavigation"]}
											onChange={(arrowNavigation) => {
												setAttributes({ slider_options: { ...slider_options, arrowNavigation } })
											}}
										/>

										{slider_options["arrowNavigation"] && <SelectControl
											label={__('Arrow Position', 'classified-listing')}
											options={ARROW_POSITION}
											value={slider_options["arrowPosition"]}
											onChange={(arrowPosition) => {
												setAttributes({ slider_options: { ...slider_options, arrowPosition } })
											}}
										/>}

										<ToggleControl
											label={__("Dot Navigation", "classified-listing")}
											checked={slider_options["dotNavigation"]}
											onChange={(dotNavigation) => {
												setAttributes({ slider_options: { ...slider_options, dotNavigation } })
											}}
										/>

										{slider_options["dotNavigation"] && <SelectControl
											label={__('Dot style', 'classified-listing')}
											options={DOT_STYLE_OPTIONS}
											value={slider_options["dotStyle"]}
											onChange={(dotStyle) => {
												setAttributes({ slider_options: { ...slider_options, dotStyle } })
											}}
										/>}

										<ToggleControl
											label={__("Slider Loader", "classified-listing")}
											checked={slider_options["sliderLoader"]}
											onChange={(sliderLoader) => setAttributes({
												slider_options: { ...slider_options, sliderLoader }
											})}
										/>
									</PanelBody>

									<PanelBody title={__('Number of Responsive cols', 'classified-listing')} initialOpen={false}>
										<SelectControl
											label={__('Desktops: >1199px', 'classified-listing')}
											options={COL_OPTIONS}
											value={col_xl}
											onChange={(col_xl) => {
												setAttributes({ col_xl })
											}}
										/>
										<SelectControl
											label={__('Desktops: >991px', 'classified-listing')}
											options={COL_OPTIONS}
											value={col_lg}
											onChange={(col_lg) => {
												setAttributes({ col_lg })
											}}
										/>
										<SelectControl
											label={__('Tablets: >767px', 'classified-listing')}
											options={COL_OPTIONS}
											value={col_md}
											onChange={(col_md) => {
												setAttributes({ col_md })
											}}
										/>
										<SelectControl
											label={__('Phones: >575px', 'classified-listing')}
											options={COL_OPTIONS}
											value={col_sm}
											onChange={(col_sm) => {
												setAttributes({ col_sm })
											}}
										/>
										<SelectControl
											label={__('Small Phones: <576px', 'classified-listing')}
											options={COL_OPTIONS}
											value={col_mobile}
											onChange={(col_mobile) => {
												setAttributes({ col_mobile })
											}}
										/>
									</PanelBody>

								</>
							)}

							{tab.name === "styles" && (
								<>
									<PanelBody title={__("Box", "classified-listing")} initialOpen={true}>

										{col_style["style"] != "2" &&
											<>
												<UnitControl
													selectedUnit={col_padding["unit"]}
													unitTypes={[
														{ label: "px", value: "px" },
														{ label: "em", value: "em" },
														{ label: "%", value: "%" },
													]}
													onClick={(unit) =>
														setAttributes({
															col_padding: { ...col_padding, unit }
														})
													}
												/>

												<DimensionsControl
													label={__("Padding", "classified-listing")}
													top={col_padding["top"]}
													right={col_padding["right"]}
													bottom={col_padding["bottom"]}
													left={col_padding["left"]}
													onChange={({ top, right, bottom, left }) =>
														setAttributes({
															col_padding: { ...col_padding, top, bottom, left, right }
														})
													}
												/>
											</>
										}
										{col_style["style"] == "2" && <PanelBody title={__("Header Style")} initialOpen={false}>
											<BaseControl>
												<ButtonGroup className="rtcl-gb-inspector-btn-group">
													{NORMAL_HOVER.map((item) => (
														<Button
															isLarge
															isPrimary={headerColorStyle === item.value}
															isSecondary={headerColorStyle !== item.value}
															onClick={() => setAttributes({ headerColorStyle: item.value })}
														>
															{item.label}
														</Button>
													))}
												</ButtonGroup>
											</BaseControl>

											{headerColorStyle == 'normal' &&
												<>
													<BaseControl label={__("Background", "classified-listing")}>
														<ColorPalette
															className="rtcl-gb-colorpalette"
															colors={COLORS}
															value={headerBGColor}
															onChange={(headerBGColor) => setAttributes({
																headerBGColor
															})}
														/>
													</BaseControl>
													<ColorControl
														label={__("Header Border Color")}
														color={headerBDColor}
														onChange={(headerBDColor) => setAttributes({
															headerBDColor
														})
														}
													/>
												</>
											}

											{headerColorStyle == 'hover' &&
												<>
													<BaseControl label={__("Background", "classified-listing")}>
														<ColorPalette
															className="rtcl-gb-colorpalette"
															colors={COLORS}
															value={headerHoverBGColor}
															onChange={(headerHoverBGColor) => setAttributes({
																headerHoverBGColor
															})}
														/>
													</BaseControl>
													<ColorControl
														label={__("Header Border Color")}
														color={headerHoverBDColor}
														onChange={(headerHoverBDColor) => setAttributes({
															headerHoverBDColor
														})
														}
													/>
												</>
											}

											<UnitControl
												selectedUnit={header_padding["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) =>
													setAttributes({
														header_padding: { ...header_padding, unit }
													})
												}
											/>
											<DimensionsControl
												label={__("Header Padding", "classified-listing")}
												top={header_padding["top"]}
												right={header_padding["right"]}
												bottom={header_padding["bottom"]}
												left={header_padding["left"]}
												onChange={({ top, right, bottom, left }) =>
													setAttributes({
														header_padding: { ...header_padding, top, bottom, left, right }
													})
												}
											/>
										</PanelBody>}

										{col_style["style"] == "2" && <PanelBody title={__("Body Style")} initialOpen={false}>
											<UnitControl
												selectedUnit={sub_cat_padding["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) =>
													setAttributes({
														sub_cat_padding: { ...sub_cat_padding, unit }
													})
												}
											/>

											<DimensionsControl
												label={__("Padding", "classified-listing")}
												top={sub_cat_padding["top"]}
												right={sub_cat_padding["right"]}
												bottom={sub_cat_padding["bottom"]}
												left={sub_cat_padding["left"]}
												onChange={({ top, right, bottom, left }) =>
													setAttributes({
														sub_cat_padding: { ...sub_cat_padding, top, bottom, left, right }
													})
												}
											/>
										</PanelBody>}

										<PanelBody title={__("Background")} initialOpen={false}>
											<BaseControl>
												<ButtonGroup className="rtcl-gb-inspector-btn-group">
													{NORMAL_HOVER.map((item) => (
														<Button
															isLarge
															isPrimary={colBGColorStyle === item.value}
															isSecondary={colBGColorStyle !== item.value}
															onClick={() => setAttributes({
																colBGColorStyle: item.value
															})}
														>
															{item.label}
														</Button>
													))}
												</ButtonGroup>
											</BaseControl>

											{colBGColorStyle === "normal" && (
												<ColorPalette
													className="rtcl-gb-colorpalette"
													colors={COLORS}
													value={colBGColor}
													onChange={(colBGColor) => setAttributes({
														colBGColor
													})}
												/>
											)}

											{colBGColorStyle === "hover" && (
												<ColorPalette
													className="rtcl-gb-colorpalette"
													colors={COLORS}
													value={colBGHoverColor}
													onChange={(colBGHoverColor) => setAttributes({
														colBGHoverColor
													})}
												/>
											)}
										</PanelBody>

										<PanelBody title={__("Border")} initialOpen={false}>
											<ColorControl
												label={__("Border Color")}
												color={colBorderColor}
												onChange={(colBorderColor) => setAttributes({
													colBorderColor
												})
												}
											/>

											<BaseControl label={__("Width", "classified-listing")}>
												<UnitControlEMG
													value={colBorderWith}
													onChange={(colBorderWith) => setAttributes({
														colBorderWith
													})
													}
												/>
											</BaseControl>

											<BaseControl label={__("Radius Width", "classified-listing")}>
												<UnitControlEMG
													value={colBorderRadius}
													onChange={(colBorderRadius) => setAttributes({
														colBorderRadius
													})
													}
												/>
											</BaseControl>
										</PanelBody>


										<PanelBody title={__("Box Shadow")} initialOpen={false}>
											<BaseControl>
												<ButtonGroup className="rtcl-gb-inspector-btn-group">
													{NORMAL_HOVER.map((item) => (
														<Button
															isLarge
															isPrimary={colBoxShadowStyle === item.value}
															isSecondary={colBoxShadowStyle !== item.value}
															onClick={() => setAttributes({
																colBoxShadowStyle: item.value
															})}
														>
															{item.label}
														</Button>
													))}
												</ButtonGroup>
											</BaseControl>

											{colBoxShadowStyle === "normal" && (
												<BaseControl>
													<ColorControl
														label={__("Color")}
														color={colBoxShadow['color']}
														onChange={(color) => setAttributes({
															colBoxShadow: { ...colBoxShadow, color }
														})}
													/>
													<RangeControl
														label={__("Horizontal")}
														value={parseInt(colBoxShadow['width']["top"])}
														onChange={(top) => setAttributes({
															colBoxShadow: { ...colBoxShadow, width: { ...colBoxShadow['width'], top } }
														})}
														min={0}
														max={100}
													/>
													<RangeControl
														label={__("Vertical")}
														value={parseInt(colBoxShadow['width']["right"])}
														onChange={(right) => setAttributes({
															colBoxShadow: { ...colBoxShadow, width: { ...colBoxShadow['width'], right } }
														})}
														min={0}
														max={100}
													/>
													<RangeControl
														label={__("Blur")}
														value={parseInt(colBoxShadow['width']["bottom"])}
														onChange={(bottom) => setAttributes({
															colBoxShadow: { ...colBoxShadow, width: { ...colBoxShadow['width'], bottom } }
														})}
														min={0}
														max={100}
													/>
													<RangeControl
														label={__("Spread")}
														value={parseInt(colBoxShadow['width']["left"])}
														onChange={(left) => setAttributes({
															colBoxShadow: { ...colBoxShadow, width: { ...colBoxShadow['width'], left } }
														})}
														min={0}
														max={100}
													/>
													<SelectControl
														label={__('Position', 'classified-listing')}
														options={
															[
																{ label: __("Outline"), value: "" },
																{ label: __("Inset"), value: "inset" },
															]
														}
														value={colBoxShadow["inset"]}
														onChange={(inset) => {
															setAttributes({ colBoxShadow: { ...colBoxShadow, inset } })
														}}
													/>
												</BaseControl>
											)}

											{colBoxShadowStyle === "hover" && (
												<BaseControl>
													<ColorControl
														label={__("Color")}
														color={colBoxShadowHover['color']}
														onChange={(color) => setAttributes({
															colBoxShadowHover: { ...colBoxShadowHover, color }
														})}
													/>
													<RangeControl
														label={__("Horizontal")}
														value={parseInt(colBoxShadowHover['width']["top"])}
														onChange={(top) => setAttributes({
															colBoxShadowHover: { ...colBoxShadowHover, width: { ...colBoxShadowHover['width'], top } }
														})}
														min={0}
														max={100}
													/>
													<RangeControl
														label={__("Vertical")}
														value={parseInt(colBoxShadowHover['width']["right"])}
														onChange={(right) => setAttributes({
															colBoxShadowHover: { ...colBoxShadowHover, width: { ...colBoxShadowHover['width'], right } }
														})}
														min={0}
														max={100}
													/>
													<RangeControl
														label={__("Blur")}
														value={parseInt(colBoxShadowHover['width']["bottom"])}
														onChange={(bottom) => setAttributes({
															colBoxShadowHover: { ...colBoxShadowHover, width: { ...colBoxShadowHover['width'], bottom } }
														})}
														min={0}
														max={100}
													/>
													<RangeControl
														label={__("Spread")}
														value={parseInt(colBoxShadowHover['width']["left"])}
														onChange={(left) => setAttributes({
															colBoxShadowHover: { ...colBoxShadowHover, width: { ...colBoxShadowHover['width'], left } }
														})}
														min={0}
														max={100}
													/>
													<SelectControl
														label={__('Position', 'classified-listing')}
														options={
															[
																{ label: __("Outline"), value: "" },
																{ label: __("Inset"), value: "inset" },
															]
														}
														value={colBoxShadowHover["inset"]}
														onChange={(inset) => {
															setAttributes({ colBoxShadowHover: { ...colBoxShadowHover, inset } })
														}}
													/>
												</BaseControl>
											)}
										</PanelBody>

									</PanelBody>

									{content_visibility["icon"] && icon_type === 'icon' ?
										<PanelBody title={__("Icon", "classified-listing")} initialOpen={false}>
											<BaseControl>
												<ButtonGroup className="rtcl-gb-inspector-btn-group">
													{NORMAL_HOVER.map((item) => (
														<Button
															isLarge
															isPrimary={iconColorStyle === item.value}
															isSecondary={iconColorStyle !== item.value}
															onClick={() => setAttributes({ iconColorStyle: item.value })}
														>
															{item.label}
														</Button>
													))}
												</ButtonGroup>
											</BaseControl>

											{iconColorStyle === "normal" && (
												<ColorControl
													label={__("Icon Color")}
													color={iconColor}
													onChange={(iconColor) => setAttributes({
														iconColor
													})
													}
												/>

											)}

											{iconColorStyle === "hover" && (
												<ColorControl
													label={__("Icon Color")}
													color={iconHoverColor}
													onChange={(iconHoverColor) => setAttributes({
														iconHoverColor
													})
													}
												/>

											)}

											{col_style['style'] === '1' &&
												<>
													<ColorControl
														label={__("Background Color")}
														color={iconBGColor}
														onChange={(iconBGColor) => setAttributes({
															iconBGColor
														})
														}
													/>
													<BaseControl label={__("Icon Area", "classified-listing")}>
														<UnitControlEMG
															value={iconArea}
															onChange={(iconArea) => setAttributes({
																iconArea
															})
															}
														/>
													</BaseControl>

													<RangeControl
														label={__("Icon Size")}
														value={iconFontSize}
														onChange={(iconFontSize) => setAttributes({
															iconFontSize
														})}
														min={0}
														max={100}
													/>
													<SelectControl
														label={__('Border Style', 'classified-listing')}
														options={BORDER_STYLES}
														value={iconBorderStyle}
														onChange={(iconBorderStyle) => {
															setAttributes({ iconBorderStyle })
														}}
													/>
													<ColorControl
														label={__("Border Color")}
														color={iconBorderColor}
														onChange={(iconBorderColor) => setAttributes({
															iconBorderColor
														})
														}
													/>
													<BaseControl label={__("Border Width", "classified-listing")}>
														<UnitControlEMG
															value={iconBorderWith}
															onChange={(iconBorderWith) => setAttributes({
																iconBorderWith
															})
															}
														/>
													</BaseControl>

													<BaseControl label={__("Border Radius", "classified-listing")}>
														<UnitControlEMG
															value={iconBorderRadius}
															onChange={(iconBorderRadius) => setAttributes({
																iconBorderRadius
															})
															}
														/>
													</BaseControl>
												</>
											}

										</PanelBody>
										: ''}

									<PanelBody title={__("Title", "classified-listing")} initialOpen={false} >
										<BaseControl>
											<ButtonGroup className="rtcl-gb-inspector-btn-group">
												{NORMAL_HOVER.map((item) => (
													<Button
														isLarge
														isPrimary={titleColorStyle === item.value}
														isSecondary={titleColorStyle !== item.value}
														onClick={() => setAttributes({
															titleColorStyle: item.value
														})}
													>
														{item.label}
													</Button>
												))}
											</ButtonGroup>
										</BaseControl>

										{titleColorStyle === "normal" && (
											<ColorControl
												label={__("Title Text Color")}
												color={titleColor}
												onChange={(titleColor) => setAttributes({
													titleColor
												})
												}
											/>
										)}

										{titleColorStyle === "hover" && (
											<ColorControl
												label={__("Title Text Color")}
												color={titleHoverColor}
												onChange={(titleHoverColor) => setAttributes({
													titleHoverColor
												})
												}
											/>
										)}

										<BaseControl label={__("Typography")} className="rtcl-gb-typography-base">
											<Dropdown
												className="rtcl-gb-typography-dropdown"
												contentClassName="my-popover-content-classname"
												position="bottom right"
												renderToggle={({ isOpen, onToggle }) => (
													<Button
														isSmall
														onClick={onToggle}
														aria-expanded={isOpen}
														icon="edit"
													></Button>
												)}
												renderContent={() => (
													<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
														<UnitControl
															selectedUnit={titleTypo["size"]["unit"]}
															unitTypes={[
																{ label: "px", value: "px" },
																{ label: "%", value: "%" },
																{ label: "em", value: "em" },
															]}
															onClick={(unit) => setAttributes({
																titleTypo: { ...titleTypo, size: { ...titleTypo["size"], unit } }
															})}
														/>

														<RangeControl
															label={__("Font Size")}
															value={parseInt(titleTypo["size"]["lg"])}
															onChange={(lg) => setAttributes({
																titleTypo: { ...titleTypo, size: { ...titleTypo["size"], lg } }
															})}
															min={0}
															step={TITLE_SIZE_STEP}
															max={TITLE_SIZE_MAX}
														/>

														<SelectControl
															label={__("Font Weight")}
															value={titleTypo["weight"]}
															options={FONT_WEIGHTS}
															onChange={(weight) =>
																setAttributes({ titleTypo: { ...titleTypo, weight } })
															}
														/>

														<SelectControl
															label={__("Text Transform")}
															value={titleTypo["transform"]}
															options={TEXT_TRANSFORM}
															onChange={(transform) =>
																setAttributes({ titleTypo: { ...titleTypo, transform } })
															}
														/>

														<RangeControl
															label={__("Letter Spacing")}
															value={parseInt(titleTypo["spacing"]["lg"])}
															onChange={(lg) =>
																setAttributes({ titleTypo: { ...titleTypo, spacing: { ...titleTypo["spacing"], lg } } })
															}
															min={0}
															max={10}
														/>

														<RangeControl
															label={__("Line Height")}
															value={parseInt(titleTypo["height"]["lg"])}
															onChange={(lg) =>
																setAttributes({ titleTypo: { ...titleTypo, height: { ...titleTypo["height"], lg } } })
															}
															min={-1}
															max={100}
														/>

													</div>
												)}
											/>
										</BaseControl>

										<BaseControl>
											<UnitControl
												selectedUnit={title_margin["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) =>
													setAttributes({
														title_margin: { ...title_margin, unit }
													})
												}
											/>
											<DimensionsControl
												label={__("Description Spacing", "classified-listing")}
												top={title_margin["top"]}
												right={title_margin["right"]}
												bottom={title_margin["bottom"]}
												left={title_margin["left"]}
												onChange={({ top, right, bottom, left }) =>
													setAttributes({
														title_margin: { ...title_margin, top, bottom, left, right }
													})
												}
											/>
										</BaseControl>

									</PanelBody>

									{content_visibility["counter"] &&
										<PanelBody title={__("Counter", "classified-listing")} initialOpen={false} >
											<BaseControl>
												<ButtonGroup className="rtcl-gb-inspector-btn-group">
													{NORMAL_HOVER.map((item) => (
														<Button
															isLarge
															isPrimary={counterColorStyle === item.value}
															isSecondary={counterColorStyle !== item.value}
															onClick={() => setAttributes({ counterColorStyle: item.value })}
														>
															{item.label}
														</Button>
													))}
												</ButtonGroup>
											</BaseControl>

											{counterColorStyle === "normal" && (
												<ColorControl
													label={__("Counter Text Color")}
													color={counterColor}
													onChange={(counterColor) => setAttributes({
														counterColor
													})
													}
												/>
											)}

											{counterColorStyle === "hover" && (
												<ColorControl
													label={__("Counter Text Color")}
													color={counterHoverColor}
													onChange={(counterHoverColor) => setAttributes({
														counterHoverColor
													})
													}
												/>
											)}

											<RangeControl
												label={__("Font Size")}
												value={counterFontSize}
												onChange={(counterFontSize) => setAttributes({
													counterFontSize
												})}
												min={0}
												max={100}
											/>

											<BaseControl>
												<UnitControl
													selectedUnit={counter_margin["unit"]}
													unitTypes={[
														{ label: "px", value: "px" },
														{ label: "em", value: "em" },
														{ label: "%", value: "%" },
													]}
													onClick={(unit) =>
														setAttributes({
															counter_margin: { ...counter_margin, unit }
														})
													}
												/>
												<DimensionsControl
													label={__("Description Spacing", "classified-listing")}
													top={counter_margin["top"]}
													right={counter_margin["right"]}
													bottom={counter_margin["bottom"]}
													left={counter_margin["left"]}
													onChange={({ top, right, bottom, left }) =>
														setAttributes({
															counter_margin: { ...counter_margin, top, bottom, left, right }
														})
													}
												/>
											</BaseControl>


										</PanelBody>
									}

									{col_style["style"] == "2" && <PanelBody title={__("Sub Category ", "classified-listing")} initialOpen={false} >
										<BaseControl>
											<ButtonGroup className="rtcl-gb-inspector-btn-group">
												{NORMAL_HOVER.map((item) => (
													<Button
														isLarge
														isPrimary={subCatColorStyle === item.value}
														isSecondary={subCatColorStyle !== item.value}
														onClick={() => setAttributes({
															subCatColorStyle: item.value
														})}
													>
														{item.label}
													</Button>
												))}
											</ButtonGroup>
										</BaseControl>

										{subCatColorStyle === "normal" && (
											<>
												<ColorControl
													label={__("Child List Color")}
													color={subCatColor}
													onChange={(subCatColor) => setAttributes({
														subCatColor
													})
													}
												/>
												<ColorControl
													label={__("Child List Icon Color")}
													color={subCatIconColor}
													onChange={(subCatIconColor) => setAttributes({
														subCatIconColor
													})
													}
												/>
											</>
										)}

										{subCatColorStyle === "hover" && (
											<>
												<ColorControl
													label={__("Child List Color")}
													color={subCatHoverColor}
													onChange={(subCatHoverColor) => setAttributes({
														subCatHoverColor
													})
													}
												/>
												<ColorControl
													label={__("Child List Icon Color")}
													color={subCatIconHoverColor}
													onChange={(subCatIconHoverColor) => setAttributes({
														subCatIconHoverColor
													})
													}
												/>
											</>
										)}
										<RangeControl
											label={__("Font Size")}
											value={subCatFontSize}
											onChange={(subCatFontSize) => setAttributes({
												subCatFontSize
											})}
											min={0}
											max={100}
										/>
									</PanelBody>}

									{content_visibility["catDesc"] &&
										<PanelBody title={__("Description", "classified-listing")} initialOpen={false} >
											<BaseControl>
												<ButtonGroup className="rtcl-gb-inspector-btn-group">
													{NORMAL_HOVER.map((item) => (
														<Button
															isLarge
															isPrimary={contentColorStyle === item.value}
															isSecondary={contentColorStyle !== item.value}
															onClick={() => setAttributes({
																contentColorStyle: item.value
															})}
														>
															{item.label}
														</Button>
													))}
												</ButtonGroup>
											</BaseControl>

											{contentColorStyle === "normal" && (
												<ColorControl
													label={__("Content Color")}
													color={contentColor}
													onChange={(contentColor) => setAttributes({
														contentColor
													})
													}
												/>
											)}

											{contentColorStyle === "hover" && (
												<ColorControl
													label={__("Content Color")}
													color={contentHoverColor}
													onChange={(contentHoverColor) => setAttributes({
														contentHoverColor
													})
													}
												/>
											)}

											<BaseControl label={__("Typography")} className="rtcl-gb-typography-base">
												<Dropdown
													className="rtcl-gb-typography-dropdown"
													contentClassName="my-popover-content-classname"
													position="bottom right"
													renderToggle={({ isOpen, onToggle }) => (
														<Button
															isSmall
															onClick={onToggle}
															aria-expanded={isOpen}
															icon="edit"
														></Button>
													)}
													renderContent={() => (

														<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
															<UnitControl
																selectedUnit={contentTypo["size"]["unit"]}
																unitTypes={[
																	{ label: "px", value: "px" },
																	{ label: "%", value: "%" },
																	{ label: "em", value: "em" },
																]}
																onClick={(unit) => setAttributes({
																	contentTypo: { ...contentTypo, size: { ...contentTypo["size"], unit } }
																})}
															/>

															<RangeControl
																label={__("Font Size")}
																value={parseInt(contentTypo["size"]["lg"])}
																onChange={(lg) => setAttributes({
																	contentTypo: { ...contentTypo, size: { ...contentTypo["size"], lg } }
																})}
																min={0}
																step={CONTENT_SIZE_STEP}
																max={CONTENT_SIZE_MAX}
															/>

															<SelectControl
																label={__("Font Weight")}
																value={contentTypo["weight"]}
																options={FONT_WEIGHTS}
																onChange={(weight) =>
																	setAttributes({ contentTypo: { ...contentTypo, weight } })
																}
															/>

															<SelectControl
																label={__("Text Transform")}
																value={contentTypo["transform"]}
																options={TEXT_TRANSFORM}
																onChange={(transform) =>
																	setAttributes({ contentTypo: { ...contentTypo, transform } })
																}
															/>

															<RangeControl
																label={__("Letter Spacing")}
																value={parseInt(contentTypo["spacing"]["lg"])}
																onChange={(lg) =>
																	setAttributes({ contentTypo: { ...contentTypo, spacing: { ...contentTypo["spacing"], lg } } })
																}
																min={0}
																max={10}
															/>

															<RangeControl
																label={__("Line Height")}
																value={parseInt(contentTypo["height"]["lg"])}
																onChange={(lg) =>
																	setAttributes({ contentTypo: { ...contentTypo, height: { ...contentTypo["height"], lg } } })
																}
																min={-1}
																max={100}
															/>

														</div>
													)}
												/>
											</BaseControl>

											<BaseControl>
												<UnitControl
													selectedUnit={content_margin["unit"]}
													unitTypes={[
														{ label: "px", value: "px" },
														{ label: "em", value: "em" },
														{ label: "%", value: "%" },
													]}
													onClick={(unit) =>
														setAttributes({
															content_margin: { ...content_margin, unit }
														})
													}
												/>
												<DimensionsControl
													label={__("Description Spacing", "classified-listing")}
													top={content_margin["top"]}
													right={content_margin["right"]}
													bottom={content_margin["bottom"]}
													left={content_margin["left"]}
													onChange={({ top, right, bottom, left }) =>
														setAttributes({
															content_margin: { ...content_margin, top, bottom, left, right }
														})
													}
												/>
											</BaseControl>

										</PanelBody>
									}

									{slider_options["arrowNavigation"] &&
										<PanelBody title={__("Arrow Navigation", "classified-listing")} initialOpen={false} >
											<ColorControl
												label={__("Background Color")}
												color={arrowBGColor}
												onChange={(arrowBGColor) => setAttributes({
													arrowBGColor
												})
												}
											/>
											<ColorControl
												label={__("Hover Background Color")}
												color={arrowBGHoverColor}
												onChange={(arrowBGHoverColor) => setAttributes({
													arrowBGHoverColor
												})
												}
											/>

											<ColorControl
												label={__("Icon Color")}
												color={arrowIconColor}
												onChange={(arrowIconColor) => setAttributes({
													arrowIconColor
												})
												}
											/>

											<ColorControl
												label={__("Hover Icon Color")}
												color={arrowIconHoverColor}
												onChange={(arrowIconHoverColor) => setAttributes({
													arrowIconHoverColor
												})
												}
											/>

										</PanelBody>
									}

									{slider_options["dotNavigation"] &&
										<PanelBody title={__("Dot Navigation", "classified-listing")} initialOpen={false} >
											<RangeControl
												label={__("Dot Navigation Spacing")}
												value={dotSpacing}
												onChange={(dotSpacing) => setAttributes({
													dotSpacing
												})}
												min={-50}
												max={100}
											/>

											<ColorControl
												label={__("Background Color")}
												color={dotBGColor}
												onChange={(dotBGColor) => setAttributes({
													dotBGColor
												})
												}
											/>

											<ColorControl
												label={__("Active Background Color")}
												color={dotActiveBGColor}
												onChange={(dotActiveBGColor) => setAttributes({
													dotActiveBGColor
												})
												}
											/>
										</PanelBody>
									}

								</>
							)}

							{tab.name === "advance" && (
								<>
									<PanelBody title={__("Main Wrapper", "classified-listing")} initialOpen={true}>
										<UnitControl
											selectedUnit={container_padding["unit"]}
											unitTypes={[
												{ label: "px", value: "px" },
												{ label: "em", value: "em" },
												{ label: "%", value: "%" },
											]}
											onClick={(unit) => setAttributes({
												container_padding: { ...container_padding, unit },
											})
											}
										/>
										<DimensionsControl
											label={__("Main Wrapper Padding", "classified-listing")}
											top={container_padding["top"]}
											right={container_padding["right"]}
											bottom={container_padding["bottom"]}
											left={container_padding["left"]}
											onChange={({ top, right, bottom, left }) => setAttributes({
												container_padding: { ...container_padding, top, bottom, left, right },
											})
											}
										/>
										<UnitControl
											selectedUnit={container_margin["unit"]}
											unitTypes={[
												{ label: "px", value: "px" },
												{ label: "em", value: "em" },
												{ label: "%", value: "%" },
											]}
											onClick={(unit) => setAttributes({
												container_margin: { ...container_margin, unit },
											})
											}
										/>
										<DimensionsControl
											label={__("Main Wrapper Margin", "classified-listing")}
											top={container_margin["top"]}
											right={container_margin["right"]}
											bottom={container_margin["bottom"]}
											left={container_margin["left"]}
											onChange={({ top, right, bottom, left }) => setAttributes({
												container_margin: { ...container_margin, top, bottom, left, right },
											})
											}
										/>
										<BaseControl label={__("Main Wrapper Background", "classified-listing")} >
											<ColorPalette
												className="rtcl-gb-colorpalette"
												colors={COLORS}
												value={containerBGColor}
												onChange={(containerBGColor) => setAttributes({
													containerBGColor
												})}
											/>
										</BaseControl>
									</PanelBody>
								</>
							)}

						</div>
					)}
				</TabPanel>
			</div>
		</InspectorControls>
	)

}

export default Inspector;